<template>
  <div :class="['container wide-banner', _isMobile() ? 'mobile' : '']">
    <Header />
    <div class="banner-wrap">
      <Banner />
    </div>
    <div class="home">
      <div
        class="sec-wrap"
      >
        <div class="sec-content">
          <a-row
            class="zhuanti"
            type="flex"
            justify="space-between"
          >
            <a-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
              <div
                class="zhuanti-item animate__animated animate__fadeIn"
              >
                <router-link :to="{ path: '/course/list', query: {type: 7}}">
                    <img src="../assets/paint.png" />
                  <!-- <h1>科技场馆云探索</h1> -->
                </router-link>
              </div>
            </a-col>
            <a-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
              <div
                class="zhuanti-item animate__animated animate__fadeIn"
              >
                <router-link :to="{ path: '/course/list', query: {type: 5}}">
                    <img src="../assets/ai.png" />
                    <!-- <h1>人工智能云学习</h1> -->
                </router-link>
                
              </div>
            </a-col>
            <a-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
              <div
                class="zhuanti-item animate__animated animate__fadeIn"
              >
                <router-link :to="{ path: '/course/list', query: {type: 6}}">
                    <img src="../assets/kejiguan.png" />
                  <!-- <h1>科技场馆云探索</h1> -->
                </router-link>
              </div>
            </a-col>
          </a-row>
        </div>
      </div>
      <!-- 人工智能云学习 -->
      <div class="sec-wrap">
        <div class="sec-content">
          <div class="sec-title">
            <!-- <img src="../assets/gushi.png" alt="" /> -->
            <h1 class="sec-title">人工智能云学习</h1>
            
          </div>
          <div class="sec-list">
            <router-link
                class="see-more"
                style="color: #000"
                :to="{ path: '/course/list', query: {type: 5}}">
                查看更多>>
           </router-link>
            <a-list
                :grid="{ gutter: _isMobile() ? 12 : 24, lg: 4, md: 3, sm: 2, xs: 1 }"
                :dataSource="courseList5"
                :pagination="pagination"
            >
                <a-list-item slot="renderItem" slot-scope="item">
                <a-card style="height:250px;" :bordered="false" @click="toDetail(item)">
                    <div class="img-zoom">
                    <img class="cover" :src="item.courseCover_url" alt="" />
                    </div>
                    <h3 class="title">{{ item.courseName }}</h3>
                </a-card>
                </a-list-item>
            </a-list>
            </div>
        </div>
      </div>
       <!-- 科技场馆云探索 -->
      <div class="sec-wrap">
        <div class="sec-content">
          <div class="sec-title">
            <!-- <img src="../assets/gushi.png" alt="" /> -->
            <h1 class="sec-title">科技场馆云探索</h1>
            
          </div>
          <div class="sec-list">
            <router-link
                class="see-more"
                style="color: #000"
                :to="{ path: '/course/list', query: {type: 6}}">
                查看更多>>
           </router-link>
            <a-list
                :grid="{ gutter: _isMobile() ? 12 : 24, lg: 4, md: 3, sm: 2, xs: 1 }"
                :dataSource="courseList6"
                :pagination="pagination"
            >
                <a-list-item slot="renderItem" slot-scope="item">
                <a-card style="height:250px;" :bordered="false" @click="toDetail(item)">
                    <div class="img-zoom">
                    <img class="cover" :src="item.courseCover_url" alt="" />
                    </div>
                    <h3 class="title">{{ item.courseName }}</h3>
                </a-card>
                </a-list-item>
            </a-list>
            </div>
        </div>
      </div>
    </div>
    <a-back-top />
    <Footer />
  </div>
</template>

<script>
import Vue from "vue";
import Header from "../components/Header";
import Banner from "../components/Banner";
import Footer from "../components/Footer";
import { getAction } from "@/api/manage";
import { mixinDevice } from "@/utils/mixin.js";
import { getInfo } from "@/api/login";
import "@/assets/less/animation.css";
import { jumpMixins } from "@/utils/jumpMixins";

export default {
  name: "Home",
  mixins: [mixinDevice, jumpMixins],
  components: {
    Header,
    Banner,
    Footer,
  },
  data() {
    return {
      bgUrl: "/assets/background.svg",
      courseList5: [],
      courseList6: [],
      tenantConfig: {},
      token: "",
      swiperOptions: {
        speed: 1000,
        // autoHeight: true,
        effect: this._isMobile() ? "fade" : "coverflow", //"fade"（淡入）、"cube"（方块）、"coverflow"（3d流）、"flip"（3d翻转）
        slidesPerView: 2,
        grabCursor: true,
        centeredSlides: true,
        coverflowEffect: {
          rotate: 0,
          stretch: -100,
          depth: 700,
          modifier: 0.5,
          slideShadows: false,
        },
        //显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        //设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        //自动轮播
        autoplay: {
          delay: 3000,
          //当用户滑动图片后继续自动轮播
          disableOnInteraction: true,
        },
        //开启循环模式
        loop: true,
      },
    };
  },
  created() {
    this.tenantConfig = this.$store.getters.tenantInfo;
    if (this.tenantConfig.homeBackground) {
      this.bgUrl = tenantConfig.themeConfig.homeBackground;
    }
    this.getCourseList(5);
    this.getCourseList(6);
  },
  mounted() {},
  computed: {
    avatarUrl() {
      return this.$store.state.user.info && this.$store.state.user.info.avatar
        ? "https://cast-files.oss-cn-beijing.aliyuncs.com/" +
            this.$store.state.user.info.avatar
        : "/img/avatar.png";
    },
  },
  methods: {
    zhuantiEnter(i) {
      this.currentZhuantiBg[i] = true;
    },
    zhuantiLeave(i) {
      this.currentZhuantiBg[i] = false;
    },
    getUserInfo() {
      getInfo().then((res) => {
        console.log(res);
      });
    },
    toDetail(item) {
        let route = this.$router.resolve({
        path: "/course/detail",
        query: {
          id: item.id,
        },
      });
      window.open(route.href, "_blank");
    },
    getCourseList(type) {
      getAction("/teaching/teachingCourse/showCourse", {
        column: 'orderNum',
        order: 'desc',
        courseType: type,
        pageSize: 8,
      }).then((res) => {
        if (res.success) {
            switch(type){
                case 5:
                    this.courseList5 = res.result.records;
                    break;
                case 6:
                    this.courseList6 = res.result.records;
                    break;
            }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
// 宽banner主题
.wide-banner {
  .banner {
    width: 100% !important;
    max-width: 100% !important;
  }
  .header {
    z-index: 99;
    position: absolute;
    background: #18239fa8;
    width: 100%;
  }
}
.container {
  .banner-wrap {
    .banner-bg {
      position: absolute;
      width: 100%;
    }
    .banner {
      margin: auto;
      max-width: 1200px;
      overflow: hidden;
      border-radius: 0 0 10px 10px;
    }
  }
  .home {
    background: #18239f;
  }
  /deep/.ant-list-pagination {
    text-align: center;
  }
  // background: url(../assets/bg2.jpg);
}

.box-shadow {
  box-shadow: #00000026 0px 0px 6px 0px;
}
.sec-wrap {
  // background-image:url(../assets/bg4.jpg)
  background-size: cover;
}
.sec-content {
  max-width: 1200px;
  margin: auto;
  padding: 30px 10px;
  .sec-list{
    padding: 10px;
    background: #fff;
    border-radius: 20px;
  }
  .sec-title {
    text-align: center;
    margin-top: 20px;
    font-weight: 700;
    font-size: 24px;
  //   color: #ffffff;
    color: #fff;
  //   text-shadow: #000 0px 0px 4px;
    img {
      text-align: center;
      max-height: 6rem;
      max-width: 100%;
      margin-bottom: 30px;
    }
  }
  .see-more {
    color: black;
    text-align: right;
    display: block;
  }
  .see-more:hover {
    color: #1890ff;
  }
}





.zhuanti {
  .zhuanti-item {
    // height: 115px;
    width: 300px;
    display: block;
    margin: 10px auto;
    cursor: pointer;
    img {
      height: 100%;
      width: 100%;
    }
    h1 {
      position: relative;
      top: -58px;
      left: 0;
      text-align: center;
      color: #fff;
      text-shadow: #000 0px 0px 4px;
    }
  }
  margin: 30px 0;
}

.common-title {
  h3 {
    font-size: 24px;
    font-weight: normal;
    line-height: 24px;
  }
}


.title {
  color: black;
  font-size: 15px;
  line-height: 22px;
  margin-bottom: 0;
  overflow: hidden;
}
.title:hover {
  color: #1890ff;
}
.img-zoom {
  width: 100%;
  // height: 170px;
  border-radius: 4px;
  box-shadow: rgb(179, 179, 179) 0px 0px 5px;
  img {
    width: 100%;
    height: 100%;
  }
}
.title {
  margin-top: 5px;
}
.title:hover {
  color: #1890ff;
}

.mobile {
  .header{
    position: relative !important;
    background: #4c79ff!important;
  }
  .cover {
    height: 100px !important;
  }

}
</style>